import { events } from "../data/events";
import { productData } from "../data/products";
import React from "react";
import { useContext, useState, useEffect } from "react";
const dataContext = React.createContext();

export const useContextElement = () => {
  return useContext(dataContext);
};

export default function Context({ children }) {
  const [cartProducts, setCartProducts] = useState([]);

  const [cartCourses, setCartCourses] = useState([
  
  ]);
  const [cartEvents, setCartEvents] = useState([]);
  const addCourseToCart = (video) => {
    if (!cartCourses.filter((elm) => elm.id === video.id)[0]) {
      const item = {
        ...video,
        quantity: 1,
      };
      setCartCourses((pre) => [...pre, item]);
    }
  };
  const isAddedToCartCourses = (id) => {
    if (cartCourses.filter((elm) => elm.id === id)[0]) {
      return true;
    }
    return false;
  };
  const addProductToCart = (id) => {
    if (!cartProducts.filter((elm) => elm.id === id)[0]) {
      const item = {
        ...productData.filter((elm) => elm.id === id)[0],
        quantity: 1,
      };
      setCartProducts((pre) => [...pre, item]);
    }
  };
  const isAddedToCartProducts = (id) => {
    if (cartProducts.filter((elm) => elm.id === id)[0]) {
      return true;
    }
    return false;
  };
  const addEventToCart = (id) => {
    if (!cartEvents.filter((elm) => elm.id === id)[0]) {
      const item = { ...events.filter((elm) => elm.id === id)[0], quantity: 1 };
      setCartEvents((pre) => [...pre, item]);
    }
  };
  const isAddedToCartEvents = (id) => {
    if (cartEvents.filter((elm) => elm.id === id)[0]) {
      return true;
    }
    return false;
  };

  const contextElement = {
    cartProducts,
    setCartProducts,
    addProductToCart,
    isAddedToCartProducts,

    addCourseToCart,
    isAddedToCartCourses,
    cartCourses,
    setCartCourses,

    cartEvents,
    setCartEvents,
    addEventToCart,
    isAddedToCartEvents,
  };
  return (
    <dataContext.Provider value={contextElement}>
      {children}
    </dataContext.Provider>
  );
}

const authContext = React.createContext();

export const useAuthContext = () => {
  return useContext(authContext);
};
export function AuthContext({ children }) {
  const [loggedIn, setLoggedIn] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState({});

  // Check localStorage for existing user session on app initialization
  useEffect(() => {
    const checkAuthState = () => {
      try {
        const userData = localStorage.getItem('user');
        if (userData) {
          const parsed = JSON.parse(userData);
          if (parsed.isLoggedIn && parsed.token) {
            setLoggedIn(true);
            setLoggedInUser({
              uid: parsed._id,
              email: parsed.email,
              firstName: parsed.firstName,
              lastName: parsed.lastName,
              fullName: parsed.fullName,
              role: parsed.role,
              isEmailVerified: parsed.isEmailVerified,
              isOTPVerified: parsed.isOTPVerified,
              profileImage: parsed.profileImage,
              mobileNumber: parsed.mobileNumber,
              address: parsed.address,
              state: parsed.state,
              country: parsed.country,
              personalInfo: parsed.personalInfo
            });
          }
        }
      } catch (error) {
        console.error('Error restoring auth state from localStorage:', error);
        // Clear invalid data
        localStorage.removeItem('user');
      }
    };

    checkAuthState();
  }, []);

  const contextElement = {
    loggedIn,
    loggedInUser,
    setLoggedIn,
    setLoggedInUser,
  };
  return (
    <authContext.Provider value={contextElement}>
      {children}
    </authContext.Provider>
  );
}
